<!-- src/layouts/PublicLayout.vue -->
<template>
  <div class="public-layout">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "PublicLayout",
};
</script>

<style scoped>
.public-layout {
  width: 100vw;
  height: 100vh;
  background-color: var(--bg-primary);
}
</style>
